import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UpdateActuationModel } from 'app/modules/common/entities/update-actuation.model';
import { PageLoaderService } from 'app/modules/common/services/page-loader.service';
import { SharedService } from 'app/modules/common/services/shared-service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import moment from 'moment';
import { finalize } from 'rxjs/operators';
import { ActuationService } from '../../services/actuation.service';
import { EditAuthorDialogComponent, EditAuthorDialogData } from './edit-author-dialog/edit-author-dialog.component';

interface ModifyActuationDialogData {
    actuationId: number;
    leaveId: number;
}

@Component({
    selector: 'app-modify-actuation',
    templateUrl: './modify-actuation.component.html',
    styleUrls: ['./modify-actuation.component.scss'],
    standalone: false
})
export class ModifyActuationComponent implements OnInit {

    public form: UntypedFormGroup;
    public coordinatorList: any = [];
    public maxFecha = moment();
    public isEditingComentariosEmpresa = false;

    constructor(
        private dialogRef: MatDialogRef<ModifyActuationComponent>,
        private fb: UntypedFormBuilder,
        private taskService: TaskSaveService,
        private actuacioneService: ActuationService,
        private sharedService: SharedService,
        private pageLoader: PageLoaderService,
        @Inject(MAT_DIALOG_DATA) public data: ModifyActuationDialogData,
        private dialog: MatDialog,
    ) { }


    ngOnInit(): void {
        this.InitForm();
        this.LoadCoordinatorDropdownList();
        this.FillForm();
    }


    // initialize form
    private InitForm() {
        this.form = this.fb.group({
            fecha: null,
            comentarios: null,
            comentariosEmpresa: null,
            authorReadonly: [null, Validators.required],
            Author: this.fb.group({
                Tipo: [null],
                Usuario: [null],
                Medico: [null],
                Coordinator: [null],
                Nombre: [null],
                MedicoId: [null]
            })
        });
    }


    // Fill form with actuation data
    private FillForm() {
        setTimeout(() => this.pageLoader.ShowPageLoader(), 0);
        this.actuacioneService
            .getActuation(this.data.actuationId)
            .pipe(
                finalize(() => this.pageLoader.HidePageLoader())
            )
            .subscribe(res => {
                if (res.code === 0) {
                    const actuation = res.result;
                    this.form.controls['fecha'].setValue(actuation.fecha);
                    this.form.controls['comentarios'].setValue(actuation.comentarios);
                    this.form.controls['comentariosEmpresa'].setValue(actuation.comentarioParaEmpresa);
                    this.form.controls['authorReadonly'].setValue(actuation.autor);
                    //Cambios para cargar el medicoId y el campo Autor
                    this.form.get(['Author', 'Nombre']).setValue(actuation.autor);
                    this.form.get(['Author', 'Tipo']).setValue(actuation.tipoAutor);
                    this.form.get(['Author', 'MedicoId']).setValue(actuation.medicoId);
                } else {
                    this.sharedService.ShowSnackBar('Lo siento, la obtención de los detalles de la acción ha fallado');
                    console.error("Server error: " + res.message);
                }
            }, error => {
                this.sharedService.ShowSnackBar('Lo siento, la obtención de los detalles de la acción ha fallado');
                console.error(error);
            });
    }

    // close dialog
    public Close(): void {
        this.dialogRef.close();
    }

    public startEditingComentariosEmpresa(): void {
        this.isEditingComentariosEmpresa = true;
    }

    public stopEditingComentariosEmpresa(): void {
        if (!this.form.controls['comentariosEmpresa'].value?.trim()) {
            this.isEditingComentariosEmpresa = false;
        }
    }

    // load coordinators
    private LoadCoordinatorDropdownList(): void {
        this.taskService.GetActiveCoordinator().subscribe(res => {
            if (res) {
                this.coordinatorList = res.result;
            }
        });
    }


    // do modifications
    public DoModifications(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {

            // build date
            const actuation = new UpdateActuationModel(
                this.form.controls['fecha'].value,
                this.form.controls['comentarios'].value,
                this.form.controls['comentariosEmpresa'].value,
                this.form.controls['Author'].value.Nombre,
                this.form.controls['Author'].value.Tipo,
                this.form.controls['Author'].value.MedicoId,
            );

            this.updateActuation(actuation);
        }

    }


    // update actuation
    private updateActuation(actuation: UpdateActuationModel) {
        this.pageLoader.ShowPageLoader();

        this.actuacioneService
            .updateActuation(this.data.actuationId, actuation)
            .pipe(
                finalize(() => this.pageLoader.HidePageLoader())
            )
            .subscribe(res => {
                if (res.code === 0) {
                    this.sharedService.ShowSnackBar('Se actualizó la actuación');
                    this.actuacioneService.PublishActuations(this.data.leaveId);
                    this.Close();
                } else {
                    this.sharedService.ShowSnackBar('Lo siento, el proceso falló');
                    console.error("Server error: " + res.message);
                }
            }, error => {
                this.sharedService.ShowSnackBar('Lo siento, el proceso falló');
                console.error(error);
            });
    }


    /**
     * Open edit author dialog
     */
    public openAuthorEditDialog() {
        const data: EditAuthorDialogData = {
            leaveId: this.data.leaveId,
            actuationId: this.data.actuationId,
            authorFormGroup: this.form.controls['Author'] as UntypedFormGroup,
            tipo: this.form.get(['Author','Tipo'])?.value,
        };
        const dialog = this.dialog.open(EditAuthorDialogComponent, {
            data: data,
            width: '400px',
        });

        dialog.afterClosed().subscribe((result: boolean) => {
            if (result)
                this.form.controls['authorReadonly'].setValue(this.form.controls['Author'].value.Nombre);
        });
    }

}
